module.exports = __webpack_public_path__ + "media/St 4-game console-question.42e0590f.wav";